// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'


import { string } from 'yup';

const obj =  {
	field:[
		
        { 
			title: "Topic or Keyword", 
			attr: "content",  
			value: "", 
			id:"topic",
			placeholder: "Topic or Keyword", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
	
    example:[
	
        { 
			title: "Topic or Keyword", 
			attr: "content",  
			value: "cycling", 
			id:"topic",
			placeholder: "Topic or Keyword", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`Love getting out on my bike and exploring nature! Taking a break from the hustle and bustle of everyday life to enjoy some peaceful time in the saddle. #cycling #naturelovers`,
     
        // 1. Gamers Unite!\n2. Play and Win!\n3. Game On!\n4. Let's Play Games!
       
	}
	}
	
	
	export default obj
	
	